import React from "react";

const Contact = () => {
  return (
    <div>
      <h1>Contactez-nous</h1>
      <p>Voici nos coordonnées...</p>
    </div>
  );
};

export default Contact;
